module.exports = __webpack_public_path__ + "img/Brightness.3ab779a6.svg";